import React from 'react';
import { useTranslation } from 'react-i18next';

import { FaqStyled } from './Faq.styled';

interface Props {
  icon: string;
  title: string;
  to?: any;
}

export const SubCategoryButton = (props: Props) => {
  return (
    <FaqStyled.CardBlue to={props.to}>
      <FaqStyled.IconCardBlue src={props.icon} />
      <FaqStyled.TitleCardBlue>{props.title}</FaqStyled.TitleCardBlue>
    </FaqStyled.CardBlue>
  );
};
